<button mat-flat-button class="add-child-button" (click)="onAddChild()" color="primary">
  AJOUTER
</button>
